import { Injectable, computed, signal } from '@angular/core';

function detectMacPlatform(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const platform = (navigator.platform ?? '').toLowerCase();
  const ua = (navigator.userAgent ?? '').toLowerCase();
  return platform.includes('mac') || ua.includes('mac os');
}

@Injectable({ providedIn: 'root' })
export class PlatformShortcutService {
  readonly isMac = signal(detectMacPlatform());

  /** Etiqueta del modificador para UI (`⌘` en Mac, `Ctrl` en el resto). */
  readonly searchLauncherModifierLabel = computed(() => (this.isMac() ? '⌘' : 'Ctrl'));

  /** Etiqueta accesible del modificador (`Cmd` / `Ctrl`). */
  readonly searchLauncherModifierAriaLabel = computed(() => (this.isMac() ? 'Cmd' : 'Ctrl'));

  readonly searchLauncherShortcutLabel = computed(() =>
    `${this.searchLauncherModifierLabel()} + Espacio`
  );

  readonly searchLauncherAriaLabel = computed(
    () => `Abrir búsqueda rápida (${this.searchLauncherModifierAriaLabel()} + Espacio)`
  );

  isSearchLauncherShortcut(event: KeyboardEvent): boolean {
    if (event.code !== 'Space' || event.altKey || event.shiftKey) {
      return false;
    }
    if (this.isMac()) {
      // ⌘+Espacio (estilo Spotlight) o Ctrl+Espacio si el atajo del sistema está ocupado.
      return event.metaKey || event.ctrlKey;
    }
    return event.ctrlKey && !event.metaKey;
  }
}
